import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { KeywordsAndConstants } from '../../core/keywords-and-constants';
import { Router } from '@angular/router';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ThemeService } from '../../network/services/theme.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TransactionEstimateComponent } from '../pages/common/transaction-estimate/transaction-estimate.component';
import { StringVariable } from '../../core/string-variable';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    TransactionEstimateComponent,
  ],
  // providers:[StringVariable],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent implements OnInit {
  isLogin: any;

  constructor(
    private router: Router,
    public constants: KeywordsAndConstants,
    @Inject(PLATFORM_ID) private platformId: Object,
    public _logoService: ThemeService,
    public variable: StringVariable,
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.isLogin = localStorage.getItem(this.constants.LocalStorageToken);
      if (localStorage.getItem(this.constants.LocalStorageToken)) {
        this.router.navigateByUrl('/dashboard');
      }
    }
  }

  ngOnInit(): void {}

  gotoLoginPage() {
    const hostname = window.location.hostname;

    if (hostname === 'app.mewitransfer.fr') {
      this.router.navigate(
        ['/sub-user-partner/login'],
        { state: { type: 'PARTNER' } }
      );
      return;
    }
   const themeColorsString = localStorage.getItem('themeColors');
    let isLiteMode = false;
    if (themeColorsString) {
      try {
        isLiteMode = !!JSON.parse(themeColorsString)?.userOptForLiteMode;
      } catch {}
    }
    this.router.navigate([isLiteMode ? '/partner/login' : '/customer/login']);
  }

}
